import React from 'react';
import {DmsTab} from 'Components';
import {hashHistory} from 'react-router';
import {Form, Input, Select, Button, Row, Col, message} from 'antd';
const Option = Select.Option;
const FormItem = Form.Item;
const {TextArea} = Input;
import {dictionayAdd, listDependent,dictionayDetail, dictionayModify} from '../../service/dictionary';
import {nameValidator} from '../../utils/regexp.js';
import {showSpin,hideSpin} from 'Utils';

class DictionaryAdd extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			opts: ['新建数据项'],
			detail: {},
			followFlag: false,//false独立
			dependent: [],
			addId:this.props.params.addId,
			disabled:false
		}
		this.checkSkey = this.checkSkey.bind(this);
		this.getlistDependent=this.getlistDependent.bind(this);
	}
	
	componentDidMount() {
		this.getlistDependent();
		if(this.state.addId!=0){
			this.setState({
				opts: ['编辑数据项'],
				disabled:true
			})
			dictionayDetail({id:parseInt(this.state.addId,0)}).then(res=>{
				if(res.status){
					var detail=res.data;
					if(detail.type===0){
						this.setState({
							followFlag:false,
							detail
						})
					}else{
						this.setState({
							followFlag:true,
							detail
						})
					}
				}else{
					message.error(res.message);
				}
			})
		}
		
	}
	
	getlistDependent(){
		listDependent().then(result => {
			if (result.status) {
				var dependentArr = [];
				for (var i = 0; i < result.data.length; i++) {
					var dependentObj = {};
					dependentObj.id = result.data[i].id;
					dependentObj.sKey = result.data[i].sKey;
					dependentObj.name = result.data[i].name;
					dependentArr.push(dependentObj);
				}
				this.setState({
					dependent: dependentArr
				})
			} else {
				message.error(result.message);
			}
		})
	}
	
	cancelHandle() {
		hashHistory.goBack();
	}
	
	submitHandle() {
		const {validateFields, getFieldsValue} = this.props.form;
		validateFields((errors) => {//表单校验
			if (errors) {
				return
			}//表单校验有误，则不执行下面的代码
			const data = {
				...getFieldsValue() //获取用户输入
			};
			if (data.type === '1') {
				data.type = 1;
				data.dependentDataItemId = parseInt(data.dependentDataItemId, 0);
			} else {
				data.type = 0;
				data.dependentDataItemId = 0;
			}
			if (data.active === '1') {
				data.active = 1;
			} else {
				data.active = 0;
			}

      showSpin();
			if(this.state.addId!=0){
				data.id=this.state.detail.id;
				dictionayModify(data).then(result => {
					hideSpin();
					if (result.status) {
						message.success(result.message);
						hashHistory.goBack();
					} else {
						message.error(result.message);
					}
				})
			}else{
				dictionayAdd(data).then(result => {
					hideSpin();
					if (result.status) {
						message.success(result.message);
						hashHistory.goBack();
					} else {
						message.error(result.message);
					}
				})
			}
			
		})
	}
	
	//选择框值改变
	flagChange(value) {
		if (value === '1') {
			this.setState({
				followFlag: true
			})
		} else {
			this.setState({
				followFlag: false
			})
		}
	}
	
	
	//skey正则
	checkSkey(rule, value, callback) {
		const vaReg = /^(?!_)(?!.*?_$)\w{1,50}$/;
		if (value) {
			if (!(vaReg.test(value))) {
				callback('请输入1-50位的数字、字母或下划线,但不可用下划线开头和结尾');
			}
			callback();
		}
		callback();
	}
	
	
	render() {
		const {opts, detail, followFlag,disabled} = this.state;
		const {getFieldDecorator} = this.props.form;
		return <div className='dms-body'>
			<DmsTab options={opts} defaultKey={0}>
				<Button onClick={this.cancelHandle.bind(this)}>取消</Button>
				<Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
			</DmsTab>
			<div className="dms-table-box" style={{backgroundColor: "#fff"}}>
				<Form layout="horizontal">
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="数据项Key" hasFeedback>
								{getFieldDecorator('sKey', {
									initialValue: (detail !== null && detail.sKey) ? detail.sKey : '',
									rules: [
										{
											required: true,
											message: '请输入数据项Key'
										},
										{
											validator: this.checkSkey
										}
									],
								})(<Input placeholder="请输入数据项Key,保存后不可修改" disabled={disabled}/>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="数据项名称" hasFeedback>
								{getFieldDecorator('name', {
									initialValue: (detail !== null && detail.name) ? detail.name : '',
									rules: [
										{
											required: true,
											message: '请输入数据项名称'
										},
										{
											validator: nameValidator
										}
									],
								})(<Input placeholder="请输入数据项名称"/>)}
							</FormItem>
						</Col>
					</Row>
					
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="类型">
								{getFieldDecorator('type', {
									initialValue: (detail !== null && detail.type === 1) ? '1' : '0',
									rules: [
										{
											required: true,
											message: '请选择类型'
										},
									]
								})(<Select onChange={this.flagChange.bind(this)}>
									<Option value='1'>从属</Option>
									<Option value='0'>独立</Option>
								</Select>)}
							</FormItem>
						</Col>
						{
							followFlag ?
								<Col className="gutter-row" span={12}>
									<FormItem label="从属数据项">
										{getFieldDecorator('dependentDataItemId', {
											initialValue: (detail !== null && detail.dependentDataItemId) ? detail.dependentDataItemId.toString() : '',
											rules: [
												{
													required: true,
													message: '请选择从属数据项'
												},
											]
										})(<Select
											placeholder='请选择从属数据项'
										>
											{
												this.state.dependent.map(function (item, key) {
													return <Option value={(item.id).toString()}
																   key={key}>{item.name}</Option>
												})
											}
										</Select>)}
									</FormItem>
								</Col>
								
								:
								''
						}
					</Row>
					
					<Row>
						<FormItem label="描述">
							{getFieldDecorator('description', {
								initialValue: (detail !== null && detail.description) ? detail.description : ''
							})(<TextArea rows={4}/>)}
						</FormItem>
					</Row>
					
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="有效性">
								{getFieldDecorator('active', {
									initialValue: (detail !== null && detail.active === 0) ? '0' : '1',
									rules: [
										{
											required: true,
											message: '请选择是否有效'
										},
									]
								})(<Select>
									<Option value='1'>有效</Option>
									<Option value='0'>无效</Option>
								</Select>)}
							</FormItem>
						</Col>
					</Row>
				
				</Form>
			</div>
		</div>
	}
}
export default Form.create()(DictionaryAdd)



// WEBPACK FOOTER //
// ./src/routes/dictionary/add.js